<template>
    <VideoDialog :videoLink="videoLink">
        <Paper
            :header="
                $t('companyDetail.videos.moreVideosFrom', {
                    companyName: company.data.name,
                })
            "
            v-if="otherVideos && otherVideos.length > 0"
        >
            <div v-if="!otherVideos">{{ $t('general.loading') }}...</div>
            <!-- TODO: Make this dynamic based on the actual company -->
            <Carousel
                v-else
                :items="otherVideos"
                @item-click="onVideoClick"
                :component="getComponent()"
                :noResourcesMessage="$t('companyDetail.videos.noMoreVideos')"
            />
        </Paper>
    </VideoDialog>
</template>

<script>
// Components
import VideoDialog from '~/components/miscellaneous/Video.Dialog.vue';
import VideoCarouselItem from '~/components/miscellaneous/Videos.CarouselItem';
import ExtendedVideoDialog from './ExtendedVideo.Dialog';

// Utils
import AnalyticService from '~/services/AnalyticService';
import DialogService from '~/services/DialogService';
import { mapVideos } from '~/utils/mappers/mediaMappers';

export default {
    name: 'Videos.Dialog',
    components: { VideoDialog },

    props: {
        videoLink: String,
    },

    data() {
        return {
            width: 600,
            height: 600,
        };
    },

    computed: {
        payload() {
            return this.$interfaces.dialogModal.getState().payload;
        },

        company() {
            return this.$interfaces.company
                .id(this.$route.params.id)
                .get({ reactive: true });
        },

        orgProfile() {
            if (!this.company || this.company.loading) return { loading: true };
            return this.$interfaces.organization.profile
                .id(this.company.data.externalId)
                .get({ reactive: true });
        },

        otherVideos() {
            if (this.orgProfile.loading) return;
            return mapVideos(
                this.orgProfile.data.videos.filter(
                    it => it.id != this.payload.id
                ),
                this.orgProfile.data.id
            );
        },
    },

    methods: {
        onVideoClick(item) {
            DialogService.openVideoDialog(item, ExtendedVideoDialog);
        },
        getComponent() {
            return VideoCarouselItem;
        },
        async logVideoViewEvent() {
            const video = this.payload;
            // Not log if already logged, or if there is no data to log with
            if (this.hasLoggedEvent || (!video || !video.id)) {
                return;
            }

            // Making sure the company-data is fetched before we log
            const company = await this.$interfaces.company
                .id(this.$route.params.id)
                .get();
            if (!company || !company.data || !company.data.id) {
                return;
            }

            // Start logging
            this.hasLoggedEvent = true;
            AnalyticService.videoViewEvent(
                video.id,
                company.data.id,
                video.title
            );
        },
    },

    mounted() {
        // Logging video view event. Will not log if the data is not in there store.
        // Therefore, this method is also being called in watch when the data has been fetched.
        this.logVideoViewEvent();
    },

    watch: {
        payload(newPayload, oldPayload) {
            if (!this.hasLoggedEvent || newPayload.id !== oldPayload.id) {
                this.logVideoViewEvent();
            }
        },
    },
};
</script>

<style lang="css" scoped></style>
